import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import {rem, standardFont} from '-/styles/utils';

const styles = {
    root: {
        position: 'relative',
        width: '100%'
    },
    control: {
        margin: 0,
        padding: 0,
        border: 'none',
        marginBottom: rem(17),
        minWidth: 0
    },
    flow: {
        marginBottom: rem(50),
        padding: rem(20),
        border: '1px solid gainsboro',
        borderRadius: 4,
        backgroundColor: 'white',
        '&:first-of-type': {
            marginTop: rem(30)
        },
        '&:last-child': {
            marginBottom: rem(20)
        }
    }
};

class Fieldset extends Component {
    render() {
        const {type = 'control', className = '', classes = {}, children} = this.props;
        const baseType = classes[type];
        const cls = classNames(classes.root, baseType, className);

        return <fieldset className={cls}>{children}</fieldset>
    }
}

export default injectSheet(styles)(Fieldset);
